import {
	ACTIVE_PARTNER_CATALOG,
	NEW_PARTNER_CATALOG,
} from "@/features/consignment-vendor-product/data/productCatalogFixtures";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Old path: keep links working.
export const Route = createFileRoute("/vendor/produk/$productId")({
	beforeLoad: ({ params }) => {
		const catalogProduct = [
			...ACTIVE_PARTNER_CATALOG,
			...NEW_PARTNER_CATALOG,
		].find((candidate) => candidate.productCode === params.productId);
		if (!catalogProduct)
			throw redirect({
				to: "/vendor/consignment-vendor-product",
				search: true,
				replace: true,
			});
		throw redirect({
			to: "/vendor/consignment-vendor-product/$id/detail",
			params: { id: catalogProduct.productId },
			search: true,
			replace: true,
		});
	},
});
